import styled from 'styled-components';

export const Wrapper = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		padding: 0 22px;
		.popup-wrapper {
			.top {
				display: flex;
				gap: 8px;
				align-items: center;
				height: 58px;
				padding: 17px 0;
				img {
					position: relative;
					top: 2px;
				}
				h2 {
					font-family: KBFG Text;
					font-size: 16px;
					font-weight: 700;
					line-height: 150%;
				}
			}
			.noti {
				margin-top: 19px;
				border-radius: 10px;
				background: #fae64d;
				padding: 6px 12px 7px 12px;
				color: #181602;
				text-align: center;
				font-family: Noto Sans KR;
				font-size: 11px;
				font-weight: 700;
				line-height: 160%;
				display: inline-block;
				position: relative;
				&:after {
					position: absolute;
					content: '';
					background-image: url(/images/kakao-icon.svg);
					width: 12px;
					height: 6px;
					top: 30px;
					left: 20px;
				}
			}
			h1 {
				margin-top: 17px;
				font-family: Noto Sans KR;
				font-size: 20px;
				font-weight: 700;
				line-height: 150%;
				margin-bottom: 20px;
			}
			.box {
				border-radius: 20px;
				background: #fff;
				box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.05);
				padding: 16px 18px;
				margin-top: 15px;
				.flex {
					display: flex;
					align-items: end;
					gap: 8px;
					.number {
						width: 18px;
						height: 18px;
						background-color: rgba(119, 108, 97, 0.08);
						border-radius: 50%;
						p {
							color: #776c61;
							text-align: center;
							font-family: Noto Sans KR;
							font-size: 10px;
							font-weight: 700;
							line-height: 18px;
							letter-spacing: -0.3px;
						}
					}
					.way {
						color: #666;
						font-family: Noto Sans KR;
						font-size: 12px;
						font-weight: 500;
						line-height: normal;
						letter-spacing: -0.36px;
						span {
							color: #000;
						}
					}
				}
				.imgbox {
					margin-top: 12px;
					border-radius: 12px;
					background: rgba(0, 0, 0, 0.2);
					height: 58px;
					padding: 13px;
					background-image: url(/images/way03.png);
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
				}
				.imgbox2 {
					background-image: url(/images/way04.png);
				}
			}
			.box2 {
				.flex {
					.number {
						background-color: #776c61;
						p {
							color: #fff;
						}
					}
					.way {
						color: #000;
					}
				}
			}
			.here {
				position: absolute;
				bottom: 20px;
				right: 22px;
				border-radius: 10px;
				background: #776c61;
				padding: 6px 12px 7px 12px;
				&:after {
					position: absolute;
					content: '';
					background-image: url(/images/icon-here.svg);
					width: 12px;
					height: 6px;
					top: 30px;
					right: 11px;
				}
				p {
					color: #fff;
					text-align: center;
					font-family: Noto Sans KR;
					font-size: 11px;
					font-weight: 700;
					line-height: 160%;
					position: relative;
					top: 2px;
				}
			}
		}
	}
`;
